import { Box, Container, Divider, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        py: 2,
        bgcolor: "background.paper",
        borderTop: "1px solid",
        borderColor: "divider",
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        {/* Nav links */}
        <Box
          sx={{
            display: "flex",
            justifyContent: 'center',
            gap: 3,
            mb: 2,
            flexWrap: "wrap",
          }}
        >
          <Link
            component={RouterLink}
            to="/quiz"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            Play
          </Link>

          <Link
            component={RouterLink}
            to="/leaderboard"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            Leaderboard
          </Link>

          <Link
            component={RouterLink}
            to="/teams/griffins"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            Griffins
          </Link>

          <Link
            component={RouterLink}
            to="/teams/snakes"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            Snakes
          </Link>

          <Link
            component={RouterLink}
            to="/teams/badgers"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            Badgers
          </Link>

          <Link
            component={RouterLink}
            to="/teams/eagles"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            Eagles
          </Link>

          <Link
            component={RouterLink}
            to="/about"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            About
          </Link>

           <Link
            component={RouterLink}
            to="/contact"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            Contact
          </Link>

          <Link
            component={RouterLink}
            to="/privacy"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            Privacy
          </Link>

          <Link
            component={RouterLink}
            to="/terms"
            color="text.secondary"
            underline="hover"
            variant="body2"
          >
            Terms
          </Link>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box sx={{ mb: 2 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              mb: 0.5,
              fontSize: '0.85rem',
            }}
          >
            What is The Quizzler?
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              lineHeight: 1.7,
              fontSize: '0.85rem',
            }}
          >
            The Quizzler is a fan-made Harry Potter trivia experience
            for casual fans and hopeless experts alike. Test yourself
            with hundreds of questions across multiple difficulty modes,
            join a team, climb the leaderboard, and see how your
            wizarding knowledge stacks up.
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Disclaimer */}
        <Typography
          variant="caption"
          color="text.disabled"
          sx={{
            lineHeight: 1.7,
            display: "block",
          }}
        >
          The Quizzler is an unofficial fan site and is not affiliated with,
          endorsed by, or connected to J.K. Rowling, Warner Bros.
          Entertainment, or Wizarding World Digital. All Harry Potter
          characters and related indicia are trademarks of their respective
          owners. Fan use only.
        </Typography>

        <Typography
          variant="caption"
          color="text.disabled"
          sx={{
            mt: 1,
            display: "block",
          }}
        >
          © {new Date().getFullYear()} The Quizzler
        </Typography>
      </Container>
    </Box>
  );
}